export function stripDemoMarker(value: string | null | undefined): string {
  return (value ?? "")
    .replace(/\s*\[demo-seller\]\s*/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}
